import React from 'react';
import { useListAdminStandardDocumentsQuery } from '../../../../../API/order/documents/DocumentApi';
import { WARRANTY_DEED_CATEGORY } from './GenerateDeedButton';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { downloadLatestDocument } from '../../../../../API/order/documents/downloadDocument';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../../../types/shared/UUID';

export const DownloadDeedButton: React.FC<{ isDocumentGenerating: boolean }> = ({ isDocumentGenerating }) => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const { latestDeedDocument } = useListAdminStandardDocumentsQuery(
    { orderId, categories: [WARRANTY_DEED_CATEGORY] },
    { selectFromResult: ({ data }) => ({ latestDeedDocument: data?.at(0) }) }
  );

  if (latestDeedDocument === undefined) {
    return null;
  }
  return (
    <div className={'flex-auto rounded-lg border-solid border-gray-100 p-2 shadow'}>
      <div className={'flex justify-start'}>
        <ArrowDownTrayIcon className={'mr-2 h-5 w-5'} />
        <button
          className={'hover:underline'}
          disabled={isDocumentGenerating}
          onClick={() => downloadLatestDocument(latestDeedDocument.id, latestDeedDocument.fileName)}
        >
          {latestDeedDocument?.fileName ?? ''}
        </button>
      </div>
    </div>
  );
};
